/**
 * Admin Hook - Checks if current user is an admin
 */

import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../services/firebase';
import { useAuth } from './useAuth';

export function useAdmin() {
  const { user } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setIsAdmin(false);
      setLoading(false);
      return;
    }

    const adminRef = doc(db, 'admins', user.uid);
    const unsubscribe = onSnapshot(adminRef, (snapshot) => {
      setIsAdmin(snapshot.exists() && snapshot.data()?.role === 'admin');
      setLoading(false);
    }, () => {
      setIsAdmin(false);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [user]);

  return { isAdmin, loading };
}
